<div class="custom-file text-center">
  <label [attr.for]="id" class="custom-file-label">
    <i class="fa fa-paperclip"></i><ng-content></ng-content>
  </label>
  <input [attr.id]="id" type="file" class="custom-file-input" (change)="addFile($event.target.files)">
</div>
<div *ngIf="fileName != ''">{{ 'Standard.ChosenFile' }} : {{ fileName }}</div>
